module.exports = __webpack_public_path__ + "static/media/checkpoint@2x.62fc8735.jpg";